import Footer from '../../components/Footer/Footer';
import SideBar from '../../components/SideBar/SideBar';
import NavBar1 from '../../components/Navbar1/NavBar1';
import BrandProducts from '../../components/BrandProducts/BrandProducts';


const brand = () => {

    return (
        <>
            <NavBar1 />
          
                <Footer>
                    <BrandProducts />
                
                </Footer>
           

        </>
    ) 
}

export default brand; 